"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var native_1 = __importDefault(require("styled-components/native"));
var react_native_1 = require("react-native");
var DefaultAtomValues_1 = require("../constants/DefaultAtomValues");
var OrientationEnum_1 = require("../enums/OrientationEnum");
var defaultProps = {
    color: DefaultAtomValues_1.DefaultAtomColors.lightGray,
    orientation: OrientationEnum_1.OrientationEnum.horizontal,
    thickness: 1
};
// STYLED COMPONENTS ---------------------------------------------------------------------------------------------------
var StyledLineHorizontal = native_1.default(react_native_1.View)(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  background-color: ", ";\n  height: ", ";\n  width: 100%;\n"], ["\n  background-color: ", ";\n  height: ", ";\n  width: 100%;\n"])), function (props) { return props.color; }, function (props) { return props.thickness; });
var StyledLineVertical = native_1.default(react_native_1.View)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  background-color: ", ";\n  width: ", ";\n  height: 100%;\n"], ["\n  background-color: ", ";\n  width: ", ";\n  height: 100%;\n"
    // COMPONENT -----------------------------------------------------------------------------------------------------------
])), function (props) { return props.color; }, function (props) { return props.thickness; });
// COMPONENT -----------------------------------------------------------------------------------------------------------
exports.ATLAtomLine = function (_a) {
    var color = _a.color, thickness = _a.thickness, orientation = _a.orientation;
    // Returns complete ATLAtomLine
    if (orientation === OrientationEnum_1.OrientationEnum.vertical) {
        return (react_1.default.createElement(StyledLineVertical, { color: color, thickness: thickness }));
    }
    else {
        return (react_1.default.createElement(StyledLineHorizontal, { color: color, thickness: thickness }));
    }
};
exports.ATLAtomLine.defaultProps = defaultProps;
exports.ATLAtomLine.displayName = 'ATLAtomLine';
var templateObject_1, templateObject_2;
